import { useState } from 'react';
import { Container } from '@mui/material';
import { IUser, useDocumentTitle } from '../common';
import { Tabs } from '.';

export const HelpDesk = ({ user, rpsPage, operationsPage }: { user: IUser; rpsPage?: boolean; operationsPage?: boolean; }) => {
  useDocumentTitle({ title: 'Helpdesk Support' });

  const [currentTab, setCurrentTab] = useState(0);

  return (
    <Container maxWidth="xl" style={{ padding: 0 }}>
      <Tabs user={user} currentTab={currentTab} setCurrentTab={setCurrentTab} rpsPage={rpsPage} operationsPage={operationsPage}/>
    </Container>
  );
};
